"use client";

import Container from "@/components/Container";
import RolesContent from "@/components/RolesContent";
import Section from "@/components/Section";
import { useState } from "react";

type ImageType = {
  src: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  alt: string;
};

type IncomeType = {
  title: string;
  text: string;
};

type ButtonType = {
  text: string;
  link: string;
  isTop?: boolean;
};

export type ItemContentCardType = {
  image: ImageType;
  income: IncomeType;
  title: string;
  body: string;
  bodySecondary: string;
  button: ButtonType;
};

export type ItemContentImageType = {
  image: ImageType;
};

export type ItemContentTextType = {
  title: string;
};

export type ItemType = {
  id: number;
  type: "card" | "image" | "text";
  isPro?: boolean;
  size: "one-third" | "half" | "two-third";
  content: ItemContentCardType | ItemContentImageType | ItemContentTextType;
};

type FilterType = {
  label: string;
  value: string;
};

type ExploreTheRolesType = {
  title: string;
  filters: FilterType[];
};

export type ContentType = {
  exploreTheRoles: ExploreTheRolesType;
  title: string;
  body: string;
  items: ItemType[];
};

type RolesProps = {
  section: {
    type: string;
    content: ContentType;
  };
};

const Roles = ({ section }: RolesProps) => {
  const [activeFilter, setActiveFilter] = useState("all");

  return (
    <Section isPaddingTop isPaddingBottom className="roles">
      <Container>
        <RolesContent
          content={section.content}
          activeFilter={activeFilter}
          setActiveFilter={(value: string) => setActiveFilter(value)}
        />
      </Container>
    </Section>
  );
};

export default Roles;
